// extracted by mini-css-extract-plugin
export default {"headline":"psw2Yri5bL_AjSLbNlvP","text":"z5EB_uCKKBS3_EYAdKRA","points":"gxuL1wjwCqtMX_eGMUyw","noData":"a5u_R7elUEHDddwQxOz0"};